import React from 'react';
import './SyntheseDeliveryReserve.scss';
import '../SyntheseTabs/SyntheseTab.scss';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store/store/store';
import { FicheAutocontrole } from '../../../store/types/FicheAutocontrole.Types';

interface Props {
  ficheAutocontrole: FicheAutocontrole;
}

const SyntheseDeliveryReserve: React.FC<Props> = ({ ficheAutocontrole }) => {
  
  const buildLibelleDeliveryReserve = (critere: FicheAutocontrole): string => {
    const lotNumbers = new Set<string>();

    critere.tabReserves.criterias.forEach(({ deliveryReserve }) => {
      if (deliveryReserve?.lotNumber) {
        lotNumbers.add(deliveryReserve.lotNumber);
      }
    });

    return lotNumbers.size >= 3 ? 'Renseigné' : 'Non renseigné';
  };

  const getCssDeliveryReserve = (critere: FicheAutocontrole): string => {
    const lotNumbers = new Set<string>();

    critere.tabReserves.criterias.forEach(({ deliveryReserve }) => {
      if (deliveryReserve?.lotNumber) {
        lotNumbers.add(deliveryReserve.lotNumber);
      }
    });

    return lotNumbers.size >= 3 ? 'colorLibelleDeliveryReserve' : 'colorLibelleDeliveryReserveKo';
  };


  return (
    <div className="synthese-tab">
      <div className="synthese-tab-header">      
        <div className="synthese-title-completion">
          <div className="synthese-tab-title">
            <span>Levées des remarques de pré-livraison </span>
            <span className={getCssDeliveryReserve(ficheAutocontrole)}>
             [{buildLibelleDeliveryReserve(ficheAutocontrole)}]
            </span>
          </div>
       </div>
      </div>
      <div className="synthese-bloc-deliveryReserve">
        <span>Levées des remarques de pré-livraison</span>
      </div>
    </div>
  );
};

const mapStateToProps = ({ ficheAutocontrole }: ApplicationState) => ({
  ficheAutocontrole: ficheAutocontrole.data,
});

export default connect(mapStateToProps)(SyntheseDeliveryReserve);
